import { render, staticRenderFns } from "./anchorComponent.vue?vue&type=template&id=5d1cf4eb&scoped=true"
import script from "./anchorComponent.vue?vue&type=script&lang=js"
export * from "./anchorComponent.vue?vue&type=script&lang=js"
import style0 from "./anchorComponent.vue?vue&type=style&index=0&id=5d1cf4eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1cf4eb",
  null
  
)

export default component.exports